import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '../utils/date-utils';

/**
 * Formats a date/time in the viewer's local timezone with the timezone abbreviation appended
 */
@Pipe({
  name: 'localDateTime',
  standalone: true
})
export class LocalDateTimePipe implements PipeTransform {
  transform(date: string | Date | null | undefined): string {
    if (!date) return '--';
    return DateUtils.formatISOStringToCurrentDateTime(date instanceof Date ? date.toISOString() : date);
  }
}
